export const en = {
  HOME: {
    value: '',
  },
  LOGIN: {
    value: 'login',
  },
  PLAN_MEETING: {
    value: 'plan-meeting',
  },
  PLAN_MEETING_TYPE: {
    value: 'type',
  },
  PLAN_MEETING_DOCTOR: {
    value: 'doctor',
  },
  PLAN_MEETING_SUMMARY: {
    value: 'summary',
  },
  PLAN_MEETING_SUMMARY_SMS: {
    value: 'summary-sms',
  },
  ABOUT_SCHEDULED_MEETING: {
    value: 'meeting-info',
  },
  EDIT_SCHEDULED_MEETING: {
    value: 'edit-meeting',
  },
  PAYMENT_SUMMARY: {
    value: 'payment-summary',
  },

  NEW_VISIT: {
    value: 'new-visit',
    path: 'new-visit',
    TYPE: {
      value: 'type',
      path: 'type',
    },
    TERM: {
      path: 'type/:type/term',
      value: 'term',
    },
    SPECIALIST: {
      path: 'type/:type/term/:from/:to/:slotType/specialist',
      value: 'specialist',
    },
    PATIENT_DATA: {
      value: 'patient-data',
      path: 'patient-data',
    },
    SUMMARY: {
      path: ':id/summary/:uuid/:account_id',
      value: 'summary',
    },
  },
  MAIN: {
    value: '/',
  },
  BLOG: {
    value: 'blog',
  },
  ARTICLE: {
    path: 'blog/article/:slug',
    value: 'blog/article',
  },
  SPECIALISTS: {
    value: 'specialists',
  },
  SPECIALIST: {
    path: 'specialists/:id',
    value: 'specialist',
  },

  CONTACT: {
    value: 'contact',
  },
  ERROR: {
    value: 'error',
  },
};
